import { Route, Routes } from "react-router-dom";

import React from "react";
import SchoolGroupUserDashboard from "./SchoolGroupUserDashboard";
import { SchoolsDashboard } from "../../superuser/routes/Schools";
import { SchoolGroupClassOverview } from "../../school/routes/ClassesOverview";

export const SchoolGroupUserRoutes = () => {
  return (
    <Routes>
      <Route path="home" element={<SchoolGroupUserDashboard />} />
      <Route path=":groupId/schools" element={<SchoolsDashboard />} />
      <Route
        path=":groupId/schools/:schoolId"
        element={<SchoolGroupClassOverview />}
      />
    </Routes>
  );
};
